import ConnectionStatus from "components/ConnectionStatus";

import { useGameContext } from "GameContext";
import { useWebSocket } from "WebSocketContext";
import { useNavigate } from "react-router-dom"

import React, { useEffect, useState } from "react";
import BackButton from "components/BackButton";
import BasicButton from "components/General/BasicButton";

const CreatePlayer: React.FC = () => {
  const { playerId, socket } = useWebSocket();

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Are you sure you want to leave? Data may be lost";
      if (!window.confirm(message)) {
        // User pressed "Cancel" → block unload
        event.preventDefault();
        event.returnValue = "";
      }
      // If user pressed "OK", allow unload
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const {
    gameId,
    connectedIds,
  } = useGameContext();

  const navigate = useNavigate()

  const [textVal, setText] = useState("");

  useEffect(() => {
    if (!gameId) {
      navigate("/play/join");
    }
  }, [gameId])


  function changeName(val: string) {
    if (!val) {
      console.log("No name");
      return;
    }

    const newName = val.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');

    const mes = JSON.stringify({
      kind: "UpdatePlayerInfo",
      toIds: connectedIds,
      playerId: playerId,
      newData: {
        playerName: newName,
      },
    })
    socket?.send( mes );

    navigate("/play/join/role");
  }

  const handleNext = () => {
    changeName(textVal);
  }

  return (
    <div className="flex h-[100vh] w-full items-center justify-center">
      <ConnectionStatus />

      <div className="flex flex-col items-center">
        <label className="">Enter your name</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={textVal}
            onChange={(e) => setText(e.target.value)}
            className="bg-[#7fffff] p-2 text-lg outline-none"
          />
          <BasicButton
            onClick={handleNext}
            text={"Next"}
          />
        </div>
      </div>

      <BackButton/>
    </div>
  )
}

export default CreatePlayer;
